<template>
    <div  class='detaillist'>
        <div  class='header'>
            <div class='title'>
                接收对象:{{receiverType}}
            </div>
            <div class='settingbtn'>
                <button type="button" @click='downloadList' class="btn btn-outline btn-primary">导出名单</button>
            </div>
        </div>
        <div class='section'>
          <div class='detail_list_item head'>
            <span class='num'>序号</span>
            <span class='org_name'>名称</span>
            <span class='name'>姓名</span>
             <span class='phone'>手机号</span>
              <span class='region_name'>所属区域</span>
              <span class='status' style='cursor:pointer' @click="showPopover(!isShowPop)">状态
                  <i style="font-size:'12px';" class='el-icon-arrow-down'></i>
              </span>
              
              <div v-show='isShowPop' class='pop'>
                <div style='margin-left:10px;'>
                  <el-radio v-model='statusType' label='2'>全部</el-radio>
                </div>
                <div style='margin-left:10px;'>
                  <el-radio v-model='statusType' label='0'>未读</el-radio>
                </div>
                <div style='margin-left:10px;'>
                  <el-radio v-model='statusType' label='1'>已读</el-radio>
                </div>
                </div>
            </div>
            <div v-for='(item,index) in data' :key='index' class='detail_list_item' v-if='showItem(item)'>
            <span class='num'>{{item.num}}</span>
            <span class='org_name'>{{item.orgName}}</span>
            <span class='name'>{{item.name}}</span>
             <span class='phone'>{{item.phone}}</span>
              <span class='region_name'>{{item.regionName}}</span>
              <span class='status'>{{item.status}}</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data () {
    return {
      isShowPop: false,
      notReaded: false,
      isReaded: false,
      isAll: false,
      statusType: '2'
    }
  },
  props: {
    receiverType: {
      type: String
    },
    id: {
      type: Number,
      default: 0
    },
    subType: {
      type: Number,
      default: 0
    },
    isShow: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array
    }
  },
  methods: {
    downloadList () {
      this.$emit('download', {statusType: this.statusType})
    },
    showPopover (val) {
      this.isShowPop = val
    },
    showItem (item) {
      // 1、显示全部
      if (this.statusType === '2') {
        return true
      } else if (this.statusType === '1') {
        if (item.status === '已读') {
          return true
        } else {
          return false
        }
      } else if (this.statusType === '0') {
        if (item.status === '未读') {
          return true
        } else {
          return false
        }
      }
    }
  },
  watch: {
    isShow (val) {
      if (val) {
        this.isShowPop = false
        this.statusType = '2'
      }
    }
  },
  computed: {
    data: {
      get () {
        if (this.isShow) {
          return this.tableData
        } else {
          return []
        }
      }
    }

  },
  mounted () {

  },
  created () {
    document.addEventListener('click', (e) => {
      // console.log(e.target.className)
      if (e.target.className !== 'status') this.isShowPop = false
    })
  }
}
</script>

<style scoped>
.detaillist{
  margin-bottom:20px;
}
.detaillist .header{
    display: flex;
    justify-content: space-between;
}
.detaillist .section{
    margin-top:20px;
    height:500px;
    padding-right:20px;
    overflow-y:scroll;
}
.settingbtn{
    float:right;
}
.detail_list_item{
  min-width:694px;;
  border-bottom:1px solid #ddd;
  border-left:1px solid #ddd;
  border-right:1px solid #ddd;
  height: 50px;
  display: flex;
  align-items:center;
}
.detail_list_item.head{
   background-color: #F5F5F5;
   border:1px solid #ddd;
}
.detail_list_item .num{
  display: inline-block;
  margin-right:-5px;
  text-align: center;
  width:90px;
}
.detail_list_item .org_name{
  display: inline-block;
  margin-right:-5px;
  text-align: center;
  /* border-right:1px solid #ddd;
  border-left:1px solid #ddd; */
  width:130px;
}
.detail_list_item .name{
  display: inline-block;
  margin-right:-5px;
  text-align: center;
  /* border-right:1px solid #ddd;
 border-left:1px solid #ddd; */
  width:150px;
}
.detail_list_item .phone{
  display: inline-block;
  margin-right:-5px;
  text-align: center;
  /* border-right:1px solid #ddd;
  border-left:1px solid #ddd; */
  width:150px;
}
.detail_list_item .region_name{
  display: inline-block;
  margin-right:-5px;
  text-align: center;
  /* border-right:1px solid #ddd;
  border-left:1px solid #ddd; */
  width:110px;
}
.detail_list_item .status{
  display: inline-block;
  margin-left:20px;
  margin-right:-5px;
  text-align: center;
  /* border-left:1px solid #ddd; */
  width:66px;
}
.pop{
  position: absolute;
  padding-top:10px;
  line-height: 30px;
  top:180px;
  right:40px;
  width:90px;
  height:120px;
  background-color:#fff;
  border:1px solid #ddd;
  box-shadow: 1px 1px 1px #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/detailList.vue